import { combineReducers } from 'redux'
import artists from './artistsReducer'
import eveniments from './evenimentsReducer'
import places from './placesReducer'

const rootReducer = combineReducers({
    artists,
    eveniments,
    places
})

export default rootReducer


// WEBPACK FOOTER //
// ./src/store/reducers/rootReducer.js